module.exports = __webpack_public_path__ + "static/img/Official Accounts.17452299.png";